import { AutoencoderGraph } from "./AutoencoderGraph";
import { CrossEntropyGraph } from "./CrossEntropyGraph";
import { LossFunction } from "./LossFunction";

function TrainingEnhancements() {
  return (
    <section id="TrainingEnhancements">
      <h3 id="TrainingEnhancements">Training Enhancements</h3>
      <p>
        We tested various SAE training methods and discovered that we could dramatically lower SAE
        losses by adding these values to an LLM’s loss function. For the models we tested,
        simultaneous training of both the SAE and LLM weights resulted in having better features. A
        combined loss function was constructed by adding the average SAE loss to the original
        cross-entropy loss used by an LLM:
      </p>
      <LossFunction />
      <p>
        To ensure that our loss function modifications did not adversely impact LLM weights, we
        compared the cross-entropy training and validation losses of the original model to the
        modified model. Both models reach a similar minimum validation loss after a similar number
        of training steps:
      </p>
      <CrossEntropyGraph />
      <p>
        To ensure that our loss function modifications resulted in SAE improvements, we evaluated
        the Gated SAE losses on a per-layer basis using both the original and modified methods of
        training. Note that, for the modified method, we froze the LLM weights after reaching
        minimum cross-entropy loss and continued training the SAE weights independently for several
        hundred more steps:
      </p>
      <AutoencoderGraph />
      <p>
        Use of the joint loss function reduced SAE losses in every layer following the first
        transformer block. It’s not clear why simultaneous training of both SAE and LLM weights
        would yield such dramatic results; however, we hypothesize that the reason might relate to
        discouraging “
        <a
          href="https://transformer-circuits.pub/2024/july-update/index.html#hurdles"
          target="_blank"
          rel="noreferrer"
        >
          cross-layer superpositioning
        </a>
        ”. The extent of improvement seems linked to the depth of the SAE layer.
      </p>
    </section>
  );
}

export { TrainingEnhancements };
